
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/expertise",
      function () {
        return require("private-next-pages/expertise/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/expertise"])
      });
    }
  